module.exports = __webpack_public_path__ + "img/logo.11ea0c6b.png";